import { CommonEventsEnum } from '@hubxtech/hubx-client-analytics-package/lib/src/enum/common/commonEventsEnum';
import { EventsEnum } from '@hubxtech/hubx-client-analytics-package/lib/src/enum/pdfGenius/eventsEnum';

import { logHubxEvent } from '@/app/providers/analytics';
import { store } from '@/store';
import type { ReviewSentiment } from '../types';

export const REVIEW_EVENTS = {
  FLOW_SHOWN: EventsEnum.REVIEW_FLOW_SHOWN,
  SENTIMENT_SELECTED: EventsEnum.REVIEW_SENTIMENT_SELECTED,
  TRUSTPILOT_PROMPT_SHOWN: EventsEnum.REVIEW_TRUSTPILOT_PROMPT_SHOWN,
  TRUSTPILOT_REVIEW: EventsEnum.REVIEW_TRUSTPILOT_REVIEW,
  TRUSTPILOT_DISMISSED: EventsEnum.REVIEW_TRUSTPILOT_DISMISSED,
  INTERNAL_FEEDBACK_PROMPT_SHOWN: EventsEnum.REVIEW_INTERNAL_FEEDBACK_PROMPT_SHOWN,
  INTERNAL_FEEDBACK_SUBMITTED: EventsEnum.REVIEW_INTERNAL_FEEDBACK_SUBMITTED,
  INTERNAL_FEEDBACK_SKIPPED: EventsEnum.REVIEW_INTERNAL_FEEDBACK_SKIPPED,
  THANK_YOU_SHOWN: EventsEnum.REVIEW_THANK_YOU_SHOWN,
} as const;

export const COMMON_REVIEW_EVENTS = {
  LND_REVIEW_US: CommonEventsEnum.LND_REVIEW_US,
  BTN_REVIEW_US: CommonEventsEnum.BTN_REVIEW_US,
} as const;

type ReviewEventName = (typeof REVIEW_EVENTS)[keyof typeof REVIEW_EVENTS];
type CommonReviewEventName =
  (typeof COMMON_REVIEW_EVENTS)[keyof typeof COMMON_REVIEW_EVENTS];

type ReviewAction = 'like' | 'dislike' | 'neutral';

export type ReviewEventPayload = {
  feature_name?: string | null;
  sentiment?: ReviewSentiment;
  feedback_text?: string;
};

type HubxLogParams = Parameters<typeof logHubxEvent>[0];

function reviewFlowId(): string {
  return String(store.getState().review?.reviewFlow ?? '');
}

function buildReviewParams(
  payload: ReviewEventPayload
): Record<string, unknown> {
  const params: Record<string, unknown> = {
    review_flow: reviewFlowId(),
    feature_name: payload.feature_name ?? '',
  };
  if (payload.sentiment) params.sentiment = payload.sentiment;
  if (payload.feedback_text) params.feedback_text = payload.feedback_text;
  return params;
}

function emit(eventName: string, eventParams: Record<string, unknown>): void {
  logHubxEvent({
    eventName,
    event_params: eventParams,
  } as unknown as HubxLogParams);
}

export function logReviewEvent(
  eventName: ReviewEventName,
  payload: ReviewEventPayload = {}
): void {
  emit(eventName, buildReviewParams(payload));
}

export function logCommonReviewEvent(
  eventName: CommonReviewEventName,
  payload: ReviewEventPayload & { action?: ReviewAction } = {}
): void {
  const { action, ...review } = payload;
  emit(eventName, {
    ...buildReviewParams(review),
    source: 'web_app',
    touchpoint: 'happy_moment_trigger',
    ...(action ? { action } : {}),
  });
}
